import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Layout, Drawer } from "antd";
import { MainHeader, VerticalMenu } from "./";
const { Content, Footer, Sider } = Layout;

const PrivateRoute: any = ({ children }: { children: JSX.Element }) => {
  const userData = useSelector((state: any) => state.authentication.userData);

  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const isLoggedIn = useSelector((state: any) => state.authentication.loggedIn);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMobileDrawerOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isLoggedIn) return <Navigate to="/login" replace />;

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileDrawerOpen(!mobileDrawerOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };

  const sidebarContent = (
    <>
      <a href="/" className="logo" style={{ display: "block", padding: "16px" }}>
        <span className="logo-sm">
          <img src={require("../assets/images/logo-da.png")} alt="Logo" style={{ maxWidth: "100%" }} />
        </span>
        <span className="logo-lg">
          <img src={require("../assets/images/logo-da.png")} alt="Logo" style={{ maxWidth: "100%" }} />
        </span>
      </a>
      <VerticalMenu onMenuClick={() => isMobile && setMobileDrawerOpen(false)} />
    </>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {userData.role === "admin" && !isMobile && (
        <Sider collapsed={collapsed} width={250}>
          {sidebarContent}
        </Sider>
      )}
      {userData.role === "admin" && isMobile && (
        <Drawer
          placement="left"
          onClose={() => setMobileDrawerOpen(false)}
          open={mobileDrawerOpen}
          width={250}
          bodyStyle={{ padding: 0 }}
        >
          {sidebarContent}
        </Drawer>
      )}
      <Layout className="site-layout">
        <MainHeader setCollapsed={toggleSidebar} isMobile={isMobile} />
        <Content>{children}</Content>
        <Footer style={{ textAlign: "center" }}>
          Монголын Үндэсний Харваачдын Холбоо ©2023 <br></br>
          DEVELOPED BY DIGITAL ARCHERY LLC
        </Footer>
      </Layout>
    </Layout>
  );
};

export default PrivateRoute;
